import { useDeleteIntegration } from 'entities/campaign-integrations';
import { Button } from 'shared/ui/Button';
import { useModalsActions } from 'shared/ui/SideModal';
import { getFirstError, isErrorsModel } from 'shared/lib/api';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';
import { useHidable } from 'shared/lib/hooks';
import { showErrorToast } from 'shared/lib/notifications';
import { ConfirmAction } from 'shared/ui/ConfirmAction';

interface Props {
  campaignId: number;
  integrationId: number;
}

export function DeleteIntegration({ campaignId, integrationId }: Props) {
  const { close } = useModalsActions();
  const timer = useHidable(false);
  const deleteIntegrationQuery = useDeleteIntegration(campaignId, integrationId);

  return (
    <div className="rounded-md border border-red-100 p-4">
      <div className="text-=slate-700 mb-4 text-sm">
        This action will remove this integration permanently and you won't be able to restore it.
      </div>
      {!timer.isShown && (
        <Button
          type="button"
          className="w-full"
          size="medium"
          onClick={timer.show}
          variant="outline-danger"
          {...getDataAutoTestAttributes(['button-delete-integration'])}
        >
          Delete integration
        </Button>
      )}
      {timer.isShown && (
        <ConfirmAction
          isConfirmLoading={deleteIntegrationQuery.isLoading}
          confirm={() => {
            deleteIntegrationQuery.mutate(
              {},
              {
                onSuccess: close,
                onError: (error) => {
                  const errorBody = error.response.data;

                  if (isErrorsModel(errorBody)) {
                    showErrorToast(getFirstError(errorBody));
                  }
                },
              }
            );
          }}
          cancel={timer.hide}
        />
      )}
    </div>
  );
}
